<template>
  <span class="truncated-copy">
    <span :title="value">
      {{ truncated }}
    </span>

    <a type="button" @click="copy" class="copy-email">
      <font-awesome-icon :icon="['fa', 'fa-copy']"> Copy </font-awesome-icon>
    </a>
  </span>
</template>

<script>
  export default {
    name: 'TruncatedCopy',

    props: {
      value: {
        type: String
      }
    },

    computed: {
      truncated() {
        if (!this.value) return ''
        return this.value.length > 6 ? this.value.slice(0, 6) + '...' : this.value
      }
    },

    methods: {
      copy() {
        navigator.clipboard.writeText(this.value)
      }
    }
  }
</script>

<style scoped>
  .truncated-copy {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
  }
</style>
